export default __webpack_public_path__ + "static/media/PEN_Xmas2021_GiftGuide_MOBILE_Page_11.9daf10cb.jpg";